import { InputTypes } from '@cashier/cashier-model';

import { ItemEnricher } from './model';

export const SelectTypeFieldEnricher: ItemEnricher = {
  shouldEnrich: (field) =>
    field.type === InputTypes.Select &&
    field.value === null &&
    field.params?.options?.length === 1,
  enrich: (field) => {
    const firstOption = field.params?.options?.[0];

    if (firstOption) {
      //for linter purposes only, since shouldEnrich already checks for this
      field.value = firstOption.value;
      field.isDisabled = true;
    }
  },
};
